import { render } from "./Venue.vue?vue&type=template&id=348fe83f&scoped=true"
import script from "./Venue.vue?vue&type=script&lang=js"
export * from "./Venue.vue?vue&type=script&lang=js"

import "./Venue.vue?vue&type=style&index=0&id=348fe83f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-348fe83f"

export default script